export default __webpack_public_path__ + "static/media/Saraswathi.a12bba61.webp";